import Auth from '.'
import Cognito from 'helpers/Cognito'
import Notification from 'store/Notification'

function startLogin () {
  return {
    type: 'START_LOGIN',
    status: Auth.LOGGING_IN,
  }
}

function firstLogin (userDetails, cognitoUser) {
  return {
    type: 'FIRST_LOGIN',
    status: Auth.FIRST_LOGIN,
    userDetails,
    cognitoUser,
  }
}

function successLogin (userDetails) {
  return {
    type: 'SUCCESS_LOGIN',
    status: Auth.LOGGED_IN,
    userDetails,
  }
}

function updateDetails (userDetails) {
  return {
    type: 'UPDATE_DETAILS',
    userDetails,
  }
}

function successLogout () {
  return {
    type: 'SUCCESS_LOGOUT',
    status: Auth.LOGGED_OUT,
  }
}

function loginFailed () {
  return {
    type: 'LOGIN_FAILED',
    status: Auth.LOGGED_OUT,
  }
}

export function setRole (role) {
  return {
    type: 'SET_ROLE',
    role,
  }
}

export function login (email, password) {
  return dispatch => {
    dispatch(startLogin())

    return Cognito.login(email, password)
    .then(({newPasswordRequired, attributes, cognitoUser}) => {
      if (newPasswordRequired) {
        return dispatch(firstLogin(attributes, cognitoUser))
      } else {
        return dispatch(successLogin(attributes))
      }
    })
    .catch(error => {
      dispatch(loginFailed())
      dispatch(Notification.error(error.message))
    })
  }
}

export function logout () {
  return dispatch => {
    window.localStorage.clear()
    return dispatch(successLogout())
  }
}

export function updateCurrentUser (attributes) {
  return dispatch => {
    return dispatch(updateDetails(attributes))
  }
}

export function activateAccount (attributes) {
  return (dispatch, getState) => {
    Cognito.activateAccount(attributes, getState().auth.cognitoUser)
    .then(() => {
      dispatch(Notification.success('User activated. Log in with the new password.'))
      dispatch(successLogout())
    })
    .catch(error => {
      dispatch(Notification.error(error.message))
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/Auth/actions.js